import React, { Component } from 'react';
import Header from './components/Header/Header';
import Main from './components/Main/Main';
import Footer from './components/Footer/Footer';
import { urlPath } from './constants.js';
import UserService from './services/UserService/UserService';

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            
        };
        this.userDataInterval = null;
        this.userService = new UserService();
        this.fetchUserData = this.fetchUserData.bind(this);
    }
    
    componentDidMount() {
        this.loadStyles();
        this.fetchUserData();
        if (!this.userDataInterval) {
            this.userDataInterval = setInterval(this.fetchUserData, 30000); // Fetch every 30s
        }
    }
    
    componentWillUnmount() {
        clearInterval(this.userDataInterval); // Clear interval on unmount
    }
    
    loadStyles = async () => {
        if (urlPath === 'user/order-history' || urlPath === 'user/open-orders') {
            await import('./css/user/custom.css');
            await import('./css/user/responsive.css');
        } else if (
            urlPath === '' || urlPath === '/' || urlPath === 'products' ||
            urlPath === 'products/' || urlPath.startsWith('downloads/') ||
            urlPath.startsWith('user/sign-up') || urlPath === 'user/my-account' ||
            urlPath === 'user/team-details' || urlPath === 'user/upload-po-files'
        ) {
            await import('./css/new-custom.css');
            await import('./css/new-responsive.css');
        } else {
            await import('./css/custom.css');
            await import('./css/responsive.css');
        }
        await import('./css/footer.css');
    };

    fetchUserData() {
        const userId = localStorage.getItem('techtop_user_id');
        if (userId) {
            this.userService.getUserData(userId).then(response => {
                const result = response.data;
                if(result.response === 'success') {
                    Object.entries(result.result.fields).forEach(([key, value]) => {
                      localStorage.setItem(`techtop_user_${key}`, typeof value === "object" ? JSON.stringify(value) : value);
                    });
                }
            });
        }
    }

    render() {
        return (
            <div className="App">
                <Header />
                <Main />
                <Footer />
            </div>
        );
    }
}

export default App;